import { FormValues } from "./types";
import { InputFile } from "./controls/file-upload/file-classes";
import { UploadedFiles } from "../forms/controls/file-upload/types";

const assignFileData = (submission: FormData, name: string, value: File) =>
    submission.append(name, value, value.name);

const assignUploadedFilesData = (
    submission: FormData,
    uploadedFiles: UploadedFiles
) => {
    if (Object.keys(uploadedFiles).length !== 0) {
        submission.append(
            "gform_uploaded_files",
            JSON.stringify(uploadedFiles)
        );
    }
};

const assignArrayData = (
    submission: FormData,
    name: string,
    value: Array<any>
) =>
    value.forEach(item =>
        submission.append(
            `${name}[]`,
            typeof item === "object" &&
                Object.prototype.hasOwnProperty.call(item, "value")
                ? item.value
                : item
        )
    );

const assignSingleSelectValue = (
    submission: FormData,
    name: string,
    option: { value: any }
) => submission.append(name, option.value);

const assignCheckboxValue = (
    submission: FormData,
    name: string,
    value: { [key: number]: any }
) =>
    Object.keys(value).forEach(
        (key: string) =>
            value[Number(key)] &&
            submission.append(
                `${name}${key}`,
                Object.prototype.hasOwnProperty.call(
                    value[Number(key)],
                    "value"
                )
                    ? value[Number(key)].value
                    : value[Number(key)]
            )
    );

const assignValue = (submission: FormData, name: string, value: any) =>
    submission.append(name, value);

const createSubmission = (values: FormValues) => {
    const formData = new FormData();
    const fileUploads: UploadedFiles = {};

    Object.keys(values).forEach(name => {
        const value = values[name];

        switch (true) {
            case Array.isArray(value): // multi-selects and time field
                assignArrayData(formData, name, value);
                break;
            case value instanceof InputFile: // single file upload
                assignFileData(formData, name, value.toFile());
                break;
            case value === Object(value): // checkboxes or single selects
                if (Object.prototype.hasOwnProperty.call(value, "value")) {
                    // single select
                    assignSingleSelectValue(formData, name, value);
                } else if (
                    Object.prototype.hasOwnProperty.call(
                        value,
                        "multiFileUpload"
                    )
                ) {
                    // multi-file uploads
                    fileUploads[name] = [];

                    for (const uploadedFile of value.uploadedFiles) {
                        fileUploads[name].push(uploadedFile.uploadedFileData);
                    }
                } else {
                    // checkboxes / multi-input
                    assignCheckboxValue(formData, "input_", value);
                }
                break;
            case value !== undefined && value !== null:
                assignValue(formData, name, value);
                break;
        }
    });

    assignUploadedFilesData(formData, fileUploads);

    return formData;
};

export default createSubmission;
